import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { OpenApplication } from '@/components/widgets/OpenApplication';
import { Layout } from '@/config/types';
import { UserEntity } from '@/entities/UserEntity';
import {
  isIbcCallCenterUser,
  isIbcStandsAgentUser,
  isIbcStandsSupervisorUser,
  isIbcTlmkAgentUser,
} from '@/hooks/layoutConstructor/iberiaUserHelpers';

const removeOpenApplicationWidgetFromLayout = (layout: Layout): void => {
  Object.values(layout.pagesByPath).forEach((page) => {
    if (!page.widgets) return;

    page.widgets = page.widgets.filter((widget) => widget.id.type !== OpenApplication);
  });
};

export const applyIberiaRestrictedUserLayout = (layout: Layout, userEntity: UserEntity): Layout => {
  if (isIbcCallCenterUser(userEntity)) {
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST];
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_DETAIL];
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.APPLICATION];
    removeOpenApplicationWidgetFromLayout(layout);
  }

  if (isIbcTlmkAgentUser(userEntity)) {
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.CHECKOUT_SESSION_LIST];
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.APPLICATION];
  }

  // Stands supervisors can't open the HPP link from the credit card detail: it is only shared after scoring
  if (isIbcStandsSupervisorUser(userEntity)) {
    removeOpenApplicationWidgetFromLayout(layout);
  }

  // Creating applications is only available through the stands flow
  if (!isIbcStandsAgentUser(userEntity)) {
    delete layout.pagesByPath[DYNAMIC_PAGE_PATHS.APPLICATION];
  }

  return layout;
};
